// import React from 'react';

// function ProjectItemsChecklist() {
//   // const powerBiUrl = "https://app.powerbi.com/onedrive/open?pbi_source=ODSPViewer&driveId=b!67j1xfhvaUOKfwGLAkMQKkGkBOl6K3lBuolGcBS2kwzd2UVW22hLQJFDrQewZKfg&itemId=01M5PKBTM4E7BDAGPKPJFLZPY2UUPUPDEN";
//   const powerBiUrl = process.env.REACT_APP_Proj_Item_Checklist;

//   return (
    
//       <iframe  title="Power BI Report"  src={powerBiUrl}  sandbox="allow-scripts allow-same-origin allow-forms allow-popups" allowFullScreen></iframe>
    
//   );
// }

// export default  ProjectItemsChecklist;

import React,{ useEffect, useState } from 'react';
import { queuedApiFetch } from '../api';

function ProjectItemsChecklist() {
    const [powerBiUrl, setPowerBiUrl] = useState('');
    const url_name='Proj_Item_Checklist';

    useEffect(() => {
        const fetchData = async () => {
            try {
                const requestOptions = { method: 'GET' };
                const data = await queuedApiFetch(
                    `/project/get_powerbi_url?url_name=${url_name}`,
                    requestOptions
                );

                if (
                    data?.apistatus?.Status_Code === 200 &&
                    data?.apistatus?.Status_Description?.toLowerCase() === 'success'
                ) {
                    setPowerBiUrl(data.data); 
                } else {
                    console.error('Failed to load Power BI URL');
                }
            } catch (err) {
                console.error('Error fetching data:', err);
            } 
        };

        fetchData();
    }, []);


    return (

        <iframe title="Power BI Report" src={powerBiUrl} sandbox="allow-scripts allow-same-origin allow-forms allow-popups" referrerpolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>

    );
}

export default ProjectItemsChecklist;
